import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "customSelectContainer" }
const _hoisted_2 = { class: "customSelectLabel" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["tabindex"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoSign = _resolveComponent("InfoSign")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.description) + " ", 1),
      (_ctx.tooltipDescription !== '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            title: _ctx.tooltipDescription
          }, [
            _createVNode(_component_InfoSign)
          ], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "customSelect",
      tabindex: _ctx.tabindex,
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["selected", { open: _ctx.open }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open = !_ctx.open))
      }, _toDisplayString(_ctx.selected), 3),
      _createElementVNode("div", {
        class: _normalizeClass(["items", { selectHide: !_ctx.open }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsData, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            onClick: ($event: any) => (_ctx.selectOption(option))
          }, _toDisplayString(option.title), 9, _hoisted_5))
        }), 128))
      ], 2)
    ], 40, _hoisted_4)
  ]))
}